import { resultsActionTypes } from '../actions/actionTypes';

export const idProofingResponseInitialState = {};
export const response = (state = idProofingResponseInitialState, action={} ) => {
    switch (action.type) {
        case resultsActionTypes.SET_ID_PROOFING_RESPONSE_DATA:
            return action.responseData;
        case resultsActionTypes.CLEAR_ID_PROOFING_RESPONSE_DATA:
            return idProofingResponseInitialState;
        default:
            return state;
    }
};


export const edeSearchResultsInitialState = [];
export const results = (state = edeSearchResultsInitialState, action={} ) => {

    switch (action.type) {
        case resultsActionTypes.SET_EDE_SEARCH_RESULTS_DATA:
            return action.resultsData;
        case resultsActionTypes.CLEAR_EDE_SEARCH_RESULTS:
            return edeSearchResultsInitialState;
        default:
            return state;
    }

};

